$(document).ready(function() {
	const form = document.querySelector('[data-ads-form]');

	if (!form) {
		return;
	}

	const submitButton = form.querySelector('[type="submit"]');
	const module = form.closest('.module-adsform');
	const status = module?.querySelector('[data-ads-form-status]');
	const errorSummary = module?.querySelector('[data-ads-form-errors]');
	const successMessage = form.dataset.successMessage || 'Votre annonce a été envoyée.';
	let toastTimer = null;

	form.noValidate = true;

	form.querySelectorAll('.frm-select2[required]').forEach((field) => {
		field.dataset.frmRequired = 'true';
		field.required = false;
	});

	const clearMessages = () => {
		if (status) {
			status.textContent = '';
			status.innerHTML = '';
			status.hidden = true;
		}

		if (errorSummary) {
			errorSummary.innerHTML = '';
			errorSummary.hidden = true;
		}

		form.querySelectorAll('[data-ads-field-error]').forEach((error) => {
			error.closest('.frm-field')?.classList.remove('frm-field--error');
			error.remove();
		});

		form.querySelectorAll('[aria-invalid="true"]').forEach((field) => {
			const describedBy = (field.getAttribute('aria-describedby') || '')
				.split(/\s+/)
				.filter((id) => id && !id.endsWith('-server-error'));

			field.removeAttribute('aria-invalid');
			if (describedBy.length) {
				field.setAttribute('aria-describedby', describedBy.join(' '));
			} else {
				field.removeAttribute('aria-describedby');
			}
		});
	};

	const showToast = (message) => {
		if (!module) {
			return;
		}

		let toast = module.querySelector('[data-ads-form-toast]');

		if (!toast) {
			toast = document.createElement('div');
			toast.className = 'module-adsform__toast';
			toast.dataset.adsFormToast = 'true';
			toast.setAttribute('role', 'status');
			toast.setAttribute('aria-live', 'polite');
			module.appendChild(toast);
		}

		toast.textContent = message;
		toast.hidden = false;
		toast.classList.add('is-visible');

		window.clearTimeout(toastTimer);
		toastTimer = window.setTimeout(() => {
			toast.classList.remove('is-visible');
		}, 4500);
	};

	const setStatus = (message, type) => {
		if (!status) {
			return;
		}

		status.textContent = message;
		status.hidden = false;
		status.dataset.state = type;
	};

	const scrollToNotification = () => {
		const target = status && !status.hidden ? status : errorSummary;

		if (!target) {
			return;
		}

		const top = target.getBoundingClientRect().top + window.scrollY - 120;
		window.scrollTo({
			top: Math.max(top, 0),
			behavior: 'smooth'
		});
		target.focus?.({ preventScroll: true });
	};

	const normalizeField = (field) => {
		if (field instanceof RadioNodeList) {
			return field[0] || null;
		}

		return field;
	};

	const getRequiredFieldValue = (field) => {
		if (field.matches('select[multiple]')) {
			return Array.from(field.selectedOptions).map((option) => option.value).join('');
		}

		if (field.type === 'checkbox' || field.type === 'radio') {
			return form.querySelectorAll(`[name="${field.name}"]:checked`).length ? 'checked' : '';
		}

		return String(field.value || '').trim();
	};

	const focusField = (field) => {
		if ($(field).data('select2')) {
			$(field).select2('open');
			return;
		}

		field.focus?.();
	};

	const scrollToField = (field) => {
		const target = field.closest('.frm-field') || field;
		const top = target.getBoundingClientRect().top + window.scrollY - 120;

		window.scrollTo({
			top: Math.max(top, 0),
			behavior: 'smooth'
		});
	};

	const addFieldError = (name, messages) => {
		const field = normalizeField(form.elements[name] || form.elements[`${name}[]`]);

		if (!field) {
			return;
		}

		const id = field.id || name;
		const error = document.createElement('p');
		error.className = 'frm-field__error';
		error.id = `${id}-server-error`;
		error.dataset.adsFieldError = 'true';
		error.textContent = messages.join(' ');

		field.setAttribute('aria-invalid', 'true');
		const fieldWrapper = field.closest('.frm-field');
		const describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);

		if (!describedBy.includes(error.id)) {
			describedBy.push(error.id);
			field.setAttribute('aria-describedby', describedBy.join(' '));
		}

		fieldWrapper?.classList.add('frm-field--error');
		(fieldWrapper?.querySelector('.frm-field__body') || fieldWrapper)?.appendChild(error);
	};

	const validateRequiredFields = () => {
		const invalidFields = Array.from(form.querySelectorAll('[required], [data-frm-required="true"]')).filter((field) => !getRequiredFieldValue(field));

		invalidFields.forEach((field) => {
			addFieldError(field.name, ['Merci de remplir ce champ avec les bonnes informations.']);
		});

		if (invalidFields.length) {
			showToast('Veuillez remplir tous les champs obligatoires.');
			scrollToField(invalidFields[0]);
			focusField(invalidFields[0]);
			return false;
		}

		return true;
	};

	const validateNativeFields = () => {
		const invalidField = Array.from(form.elements).find((field) => field.willValidate && !field.checkValidity());

		if (!invalidField) {
			return true;
		}

		showToast('Veuillez corriger le champ indiqué.');
		invalidField.reportValidity();
		return false;
	};

	const renderErrors = (errors) => {
		const items = [];

		Object.entries(errors || {}).forEach(([name, messages]) => {
			const list = Array.isArray(messages) ? messages : [String(messages)];
			addFieldError(name, list);
			items.push(...list);
		});

		if (errorSummary && items.length) {
			const list = document.createElement('ul');

			items.forEach((message) => {
				const item = document.createElement('li');
				item.textContent = message;
				list.appendChild(item);
			});

			errorSummary.appendChild(list);
			errorSummary.hidden = false;
		}
	};

	form.addEventListener('submit', async (event) => {
		event.preventDefault();
		clearMessages();

		if (!validateRequiredFields()) {
			return;
		}

		if (!validateNativeFields()) {
			return;
		}

		const originalButtonText = submitButton?.textContent;

		if (submitButton) {
			submitButton.disabled = true;
			submitButton.textContent = 'Envoi en cours...';
		}

		try {
			const response = await fetch(form.action, {
				method: 'POST',
				body: new FormData(form),
				headers: {
					Accept: 'application/json'
				}
			});
			const data = await response.json();

			if (!response.ok || !data.success) {
				renderErrors(data.errors || {});
				setStatus('Veuillez corriger les champs indiqués.', 'error');
				scrollToNotification();
				return;
			}

			form.reset();
			$(form).find('.frm-select2').val(null).trigger('change');
			form.querySelectorAll('[data-frm-file-upload] input[type="file"]').forEach((input) => {
				$(input).trigger('resetFrmFileUpload');
			});
			setStatus(successMessage, 'success');
			scrollToNotification();
		} catch (error) {
			setStatus('Une erreur est survenue. Veuillez réessayer plus tard.', 'error');
			scrollToNotification();
		} finally {
			if (submitButton) {
				submitButton.disabled = false;
				submitButton.textContent = originalButtonText;
			}
		}
	});
});
